
import { css } from 'lit';
export default css`
:host{
  position:relative;
}

.content{
  padding:0px 1.5rem 1.5rem 1.5rem;
  gap:1rem;
  border-radius:0px 0px 32px 0px;
}

.content:first-child{
  padding-top:1.5rem;
}

.teaser-card{
  position:relative;
  background-color:var(--primary-white);
  border-radius:0px 0px 32px 0px;
  height:100%;
}

.teaser-card:hover{
    background-color:var(--purple-indigo);
    color:var(--primary-white);
    transition:background-color 0.5s;
  }

.dark.teaser-card{
  background-color:var(--neutral-light);
}

.dark.teaser-card:hover{
    background-color:var(--purple-indigo);
  }

.dark .content{
  background-color:transparent;
}

.dark .content:hover{
    background-color:transparent;
  }

.tag{
  margin-bottom:0rem;
}

.image{
  border-bottom-right-radius:0px;
}

@media (min-width: 992px){
  .teaser-card{
    display:grid;
    grid-template-columns:2fr 2rem 1fr;
  }
  .content{
    grid-area:1 / 1 / 2 / 3;
    background-color:var(--primary-white);
    padding-top:1.5rem;
  }
    .content:hover{
      transition:background-color 0.5s;
      background-color:var(--purple-indigo);
    }

  .dark .content{
    background-color:var(--neutral-light);
  }
    .dark .content:hover{
      background-color:var(--purple-indigo);
    }
  .image{
    grid-area:1 / 2 / 2 / 4;
    width:calc(100% + 2px);
  }
    .image img{
      height:100%;
    }
  pc-tag{
    --font-size-pc-tag:14px;
  }
}
`;